import { SxProps, Theme } from '@mui/material';

const TOUCH_TARGET_SIZE = 44;

export const locationAlertPopperSX: SxProps<Theme> = (theme) => ({
	zIndex: theme.zIndex.drawer + 1,
	width: 'calc(100vw - 16px)',
	[theme.breakpoints.up('md')]: {
		width: 385,
	},
	[theme.breakpoints.down('md')]: {
		width: 320,
	},
});

export const locationAlertCardSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: '10px',
	padding: '10px',
	backgroundColor: 'common.white',
	borderRadius: '4px',
	boxShadow: 3,
};

export const locationAlertIconContainerSX: SxProps<Theme> = {
	display: 'flex',
	flexShrink: 0,
	alignItems: 'center',
	justifyContent: 'center',
	height: '24px',
	width: '24px',
};

export const locationAlertIconSX: SxProps<Theme> = {
	width: '18px',
	height: '18px',
	color: 'primary.main',
};

export const locationAlertBodySX: SxProps<Theme> = {
	display: 'flex',
	flexGrow: 1,
	alignItems: 'flex-start',
	minWidth: 0,
	gap: '15px',
};

export const locationAlertMessageSX: SxProps<Theme> = {
	color: 'grey.500',
	paddingTop: '2px',
};

export const locationAlertLinkSX: SxProps<Theme> = {
	color: 'secondary.main',
	fontWeight: 'inherit',
	textDecoration: 'none',
	minHeight: TOUCH_TARGET_SIZE,
	minWidth: TOUCH_TARGET_SIZE,
	textAlign: 'left',
};

export const locationAlertCloseSX: SxProps<Theme> = {
	flexShrink: 0,
	width: TOUCH_TARGET_SIZE,
	height: TOUCH_TARGET_SIZE,
	margin: '-10px -10px 0 0',
	color: 'text.primary',
};
